import React, { PropTypes, Component } from 'react';
import B from 'bem-cn';

import './index.scss';

const cl = B('Forms');

export default class Forms extends Component {
  static propTypes = {
    showedOverlay: PropTypes.string
  };

  state = { frameLoading: true };

  onLoad = () => {
    this.setState({
      frameLoading: false
    });
  };

  render() {
    const { showedOverlay } = this.props;
    const { frameLoading } = this.state;

    let frameSrc;
    switch (showedOverlay) {
      case 'forms__contactForm':
        frameSrc = 'https://docs.google.com/forms/d/e/1FAIpQLSc1WSR3I_poEEHmqo_4_cR4broQrF4_SerOnObvG9qeRiRxpQ/viewform?embedded=true';
        break;
      case 'forms__requestDemo':
        frameSrc = 'https://docs.google.com/forms/d/e/1FAIpQLSema01ro6PStF4eAED0kyRucmkdtnw6MLTcT8JAoF0829cqrQ/viewform?embedded=true';
        break;
      case 'forms__investorRelations':
        frameSrc = 'https://docs.google.com/forms/d/e/1FAIpQLScxrwJFwY2UM-GYZjXz-6HVPDkMM70KH_cavdEy-clMAQEwVg/viewform?embedded=true';
        break;
      case 'forms__registerInterest':
        frameSrc = 'https://docs.google.com/forms/d/e/1FAIpQLSfPIML2xLIfaFtspV0DfNhnHVUMb2lCe9y1iwq8vT5TvPdswQ/viewform?embedded=true';
        break;
      default:
        throw new Error('Unexpected overlay');
    }

    return (
      <div className={cl}>
        {frameLoading && <div className={cl('loading')}>Loading...</div>}
        <iframe
          title={showedOverlay.split('__')[1]}
          className={cl('frame')}
          src={frameSrc}
          frameBorder="0"
          marginHeight="0"
          marginWidth="0"
          onLoad={this.onLoad}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ../src/components/forms/index.jsx